import { useEffect, useState } from 'react'

/** `value`, settled for `ms` — keeps search-as-you-type from sending one request per keystroke. */
export function useDebounced<T>(value: T, ms = 300): T {
    const [settled, setSettled] = useState(value)
    useEffect(() => {
        const t = setTimeout(() => setSettled(value), ms)
        return () => clearTimeout(t)
    }, [value, ms])
    return settled
}
